<!-- eslint-disable no-irregular-whitespace -->
<template>
  <div id="isInitial" v-if="isInitial">
    <Loading :loading="this.loading"></Loading>
    <div v-show="!loading" class="content-wrapper" v-bind:class="{ modal_open: modalActive }">
      <noscript v-if="isViewGatag" v-html="noscriptContent"></noscript>
      <main>
      <section class="cosmo-shakencms-c-section -top cosmo-shakencms-top-s-mainvisual">
      <div class="fv_bg">
        <div class="cosmo-shakencms-c-inner">
          <div class="s-mainvisual__wrap">
            <div class="s-mainvisual__wrap__inner">
              <div class="fv_title">
                <img src="/lib/images/inspectiondetail/fv/fv_top_sp.png" alt="手軽に車検、オンラインで簡単見積り。「コスモのコミっと車検」" />
                <div class="fv_title__logo">
                  <img src="/lib/images/inspectiondetail/fv/fv_logo_sp.png" alt="COSMO" />
                </div>
              </div>
              <div class="fv_main">
                <img src="/lib/images/inspectiondetail/fv/fv_bottom_sp.png" alt="見積りからブレないから安心だよ。※" />
              </div>
            </div>
          </div>
        </div>
        <div class="fv_bg__btn">
          <div class="btn__top">
            <img src="/lib/images/inspectiondetail/fv/fv_btn_top_sp.png" alt="「３つの特徴」POINT.1「お近くのコスモSSで安心対応！」POINT.2「来店不要！オンラインで簡単見積り！」POINT.3「コミコミ価格で見積りからのブレがない」" />
          </div>
          <div class="btn__bottom">
            <a v-on:click='nextPage(ssInfo, profileInfo, nativeData, versionData)' v-if="!this.inspectionFlag">
              <img src="/lib/images/inspectiondetail/fv/fv_btn_sp.png" alt="オンラインで見積り" />
            </a>
          </div>
        </div>
      </div>
      <div class="carcare-fv-notice">
        <div class="carcare-fv-notice__inner">
          <p class="font-weight-bold">【重要なお知らせ】</p>
          <br>
          <p>現在、原材料の供給停止、不足等の影響により、一部定額対象部品の供給が不安定な状態となっております。一部定額対象部品がご用意できない場合は、以下の通り対応させていただく場合がございます。</p>
          <br>
          <p>①コミっと車検をご検討の方</p>
          <p>別の車検商品でのご案内に切り替えさせていただくことがございます。</p>
          <br>
          <p>②整備保証対象の方</p>
          <p>無償交換の対象ではございますが、対象部品の受け入れ・交換対応ができない場合がございます。</p>
          <br>
          <p>予めご了承ください。</p>
        </div>
      </div>
      </section>
      <!-- step-area -->
      <div class="step-area">
        <!-- step-area01 -->
        <section class="cosmo-shakencms-c-section -top cosmo-shakencms-top-s-price bg_third_blue step-area__height"></section>
        <!-- step-area02 -->
        <section class="cosmo-shakencms-top-s-price bg_shirosumire">
          <div class="section03">
            <div class="section03__triangle"></div>
          </div>
        </section>
        <!-- step-area03 -->
        <section class="cosmo-shakencms-c-section -top cosmo-shakencms-step step-area__absolute">
          <div class="cosmo-shakencms-c-inner section02">
            <div class="section02__title">
              <img src="/lib/images/inspectiondetail/section02/section02_title_sp.png" alt="オンラインで即見積り「コミっと車検」の流れ３ステップ" />
            </div>
          </div>
        </section>
      </div>
      <!-- / step-area -->

      <!-- section02 -->
      <section class="cosmo-shakencms-c-section -top cosmo-shakencms-step bg_shirosumire">
        <div class="cosmo-shakencms-c-inner section02 sp_padding-none">
          <div class="section02__item">
            <ul>
              <li>
                <img src="/lib/images/inspectiondetail/section02/section02_item01_sp.png" alt="Step.1「お好みの方法でカンタン見積り」Webでもアプリでも簡単に、法定費用・車検基本料・主要部品の整備費見積り金額は無料ですぐに確認できるので、ぜひお見積りください！" />
              </li>
              <li>
                <img src="/lib/images/inspectiondetail/section02/section02_item02_sp.png" alt="Step.2「来店日を予約」実施希望の日時を選択してお申込してください。こちらのご入力内容で来店日時を確定させていただきます。※一部の実施店舗や実施希望日時を選択していない場合はお申込頂いた、実施店舗からお電話をさせていただき来店日時を確定させていただきます。" />
              </li>
              <li>
                <img src="/lib/images/inspectiondetail/section02/section02_item03_sp.png" alt="Step.3「車検当日」当日は店頭にお越しください。車検完了後には、お車の状態や整備箇所をわかりやすくお伝えしてお返しします。" />
              </li>
            </ul>
          </div>
          <div class="section02__item__bottom">
            <img src="/lib/images/inspectiondetail/section02/section02_title_bottom_sp.png" alt="見積り金額は無料ですぐに確認できるので、ぜひお見積りください！" />
          </div>
        </div>
      </section>

      <!-- section04 -->
      <section class="cosmo-shakencms-top-s-price section04" id="features">
        <div class="cosmo-shakencms-c-section -top cosmo-shakencms-top-s-price bg_cream">
          <div class="cosmo-shakencms-c-inner sp_padding-none">
            <div class="section04_title">
              <img src="/lib/images/inspectiondetail/section04/section04_title_sp.png" alt="コミっと車検とは？" />
            </div>
            <div class="section04_item">
              <img src="/lib/images/inspectiondetail/section04/section04_item_sp.png" alt="法定費用＋車検基本料＋主要部品の整備費用＋アフターサービス" />
            </div>
            <div class="section04_bottom">
              <img src="/lib/images/inspectiondetail/section04/section04_title_bottom_sp.png" alt="と諸費用がコミコミなので、安心な車検サービスです！" />
            </div>
          </div>
        </div>
      </section>

      <!-- section07 -->
      <section class="cosmo-shakencms-c-section -top cosmo-shakencms-top-s-price pb">
        <div class="section07">
          <div class="cosmo-shakencms-c-inner sp_padding-none">
            <!-- title -->
            <div class="section07__title img-01">
              <img src="/lib/images/inspectiondetail/section07/section07_title-01_sp.png" alt="要するに初期の見積りから全てコミコミ※でご提示するので変動がありません！" />
            </div>
            <!-- item -->
            <div class="section07__item">
              <img src="/lib/images/inspectiondetail/section07/section07_item_sp.png" alt="" />
            </div>
            <p class="chu">※タイヤなど、交換する部品によっては、追加費用が発生する場合もあります。</p>
          </div>
        </div>
        <div class="section_btn">
          <a v-on:click='nextPage(ssInfo, profileInfo, nativeData, versionData)' v-if="!this.inspectionFlag">
            <img src="/lib/images/inspectiondetail/btn_sp.png" alt="コミっと車検無料お見積り" />
          </a>
        </div>
      </section>

      <!-- section01 -->
      <section class="cosmo-shakencms-c-section -top cosmo-shakencms-top-s-price slider-parts" id="price">
        <div class="cosmo-shakencms-c-inner slider-box slider-box_width">
          <div class="slider_title">
            <div class="slider_title__inner">
              <img src="/lib/images/inspectiondetail/section01/slider_title_sp.png" alt="" />
              <div class="slider_title__inner__text">
                <p class="responsive-font-size"><span class="color_light-blue">初年度登録から5年、走行距離50,000km</span>の車の金額がコチラ！</p>
              </div>
            </div>
            <div class="slider_title__sub">
              <p>一 例</p>
            </div>
            <div class="swiper-container js-slider__price">
              <ul class="swiper-wrapper">
                <li class="swiper-slide car_box">
                  <div class="car_box__item"><img src="/lib/images/inspectiondetail/section01/example_1.png" alt="ホンダ N-BOX 軽自動車"></div>
                  <div class="car_box__price">
                    <h3>ホンダ N-BOX<br>軽自動車</h3>
                    <p class="price">{{ inspectionReferencePrices.nbox }}<span class="tax">円（税込）～</span></p>
                  </div>
                </li>
                <li class="swiper-slide car_box">
                  <div class="car_box__item"><img src="/lib/images/inspectiondetail/section01/example_2.png" alt="トヨタ　ヤリス 車両重量：990kg"></div>
                  <div class="car_box__price">
                    <h3>トヨタ　ヤリス<br>車両重量：990kg</h3>
                    <p class="price">{{ inspectionReferencePrices.yaris }}<span class="tax">円（税込）～</span></p>
                  </div>
                </li>
                <li class="swiper-slide car_box">
                  <div class="car_box__item"><img src="/lib/images/inspectiondetail/section01/example_3.png" alt="ホンダ　ヴェゼル 車両重量：1,350㎏"></div>
                  <div class="car_box__price">
                    <h3>ホンダ　ヴェゼル<br>車両重量：1,350㎏</h3>
                    <p class="price">{{ inspectionReferencePrices.vezel }}<span class="tax">円（税込）～</span></p>
                  </div>
                </li>
                <li class="swiper-slide car_box">
                  <div class="car_box__item"><img src="/lib/images/inspectiondetail/section01/example_4.png" alt="トヨタ　ヴォクシー 車両重量：1,620kg"></div>
                  <div class="car_box__price">
                    <h3>トヨタ　ヴォクシー<br>車両重量：1,620kg</h3>
                    <p class="price">{{ inspectionReferencePrices.voxy }}<span class="tax">円（税込）～</span></p>
                  </div>
                </li>
              </ul>
              <div class="swiper-button-next"></div>
              <div class="swiper-button-prev"></div>
            </div>
          </div>

        </div>
      </section>
      </main>
      <!-- カーケアTOPに戻るボタン -->
      <form name="fm">
        <input id="tsid" type="hidden" name="tsid" v-bind:value="tsId">
        <input id="popinfoid" type="hidden" name="popinfoid" v-bind:value="popinfoid">
        <input id="otoken" type="hidden" name="otoken" v-bind:value="otoken">
        <input id="x_cls_app_version" type="hidden" name="appversion" v-bind:value="this.versionDataStore.versionData.appVersion">
        <input id="x_cls_os" type="hidden" name="platform" v-bind:value="this.versionDataStore.versionData.platform">
        <input id="x_cls_os_version" type="hidden" name="osversion" v-bind:value="this.versionDataStore.versionData.osVersion">
      </form>
    </div>
</div>
<div v-else-if="isAgreement">
  <a id="isAgreement" v-on:click="toInitial()"></a>
  <Agreement></Agreement>
</div>
</template>

<script>
import Agreement from '@/views/v3/Agreement.vue'
import Loading from '@/views/v3/Loading.vue'
import Slick from 'vue-slick'
import inspection from '@/store/Api/inspection'
import modal from '@/assets/v3/modal'
import { useSsInfoStore } from '@/store/ssInfo'
import { useProfileInfoStore } from '@/store/profileInfo'
import { useNativeDataStore } from '@/store/nativeData'
import { useVersionDataStore } from '@/store/versionData'

const IS_INITIAL = 'IS_INITIAL'
const IS_AGREEMENT = 'IS_AGREEMENT'

// 日本時間の2026年11月1日0時から、コミっと車検の料金例を改定する。
const INSPECTION_REFERENCE_PRICE_REVISION_AT = Date.parse('2026-11-01T00:00:00+09:00')
const INSPECTION_REFERENCE_PRICES_BEFORE_REVISION = { nbox: 74420, yaris: 86830, vezel: 94730, voxy: 106730 }
const INSPECTION_REFERENCE_PRICES_AFTER_REVISION = { nbox: 75540, yaris: 87740, vezel: 95640, voxy: 107640 }

export default {
  data () {
    return {
      // 画面を開いた時点の現在日時で、料金例の新旧を判定する。
      inspectionReferenceOpenedAt: Date.now(),
      loading: true,
      modalActive: false,
      tsId: null,
      ssInfo: null,
      profileInfo: null,
      nativeData: null,
      versionData: null,
      currentState: IS_INITIAL,
      popinfoid: null,
      otoken: null,
      slideshow: {
        dots: false,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        arrows: false
      },
      inspectionFlag: true,
      gaId: process.env.VUE_APP_GA_ID,
      isViewGatag: JSON.parse(process.env.VUE_APP_IS_VIEW_GA_TAG || 'false'),
      observedNodes: []
    }
  },
  beforeRouteLeave () {
    this.removePageLayout()
  },
  beforeDestroy () {
    // beforeRouteLeaveが上手く発火しなかった時の保険
    this.removePageLayout()
  },
  destroyed () {
    // beforeRouteLeaveが上手く発火しなかった時の保険
    this.removePageLayout()
  },
  computed: {
    inspectionReferencePrices () {
      const prices = this.inspectionReferenceOpenedAt >= INSPECTION_REFERENCE_PRICE_REVISION_AT ? INSPECTION_REFERENCE_PRICES_AFTER_REVISION : INSPECTION_REFERENCE_PRICES_BEFORE_REVISION
      return Object.fromEntries(Object.entries(prices).map(([car, price]) => [car, price.toLocaleString('ja-JP')]))
    },
    isInitial () {
      return this.currentState === IS_INITIAL
    },
    isAgreement () {
      return this.currentState === IS_AGREEMENT
    },
    ssInfoStore: function () {
      return useSsInfoStore()
    },
    profileInfoStore: function () {
      return useProfileInfoStore()
    },
    nativeDataStore: function () {
      return useNativeDataStore()
    },
    versionDataStore: function () {
      return useVersionDataStore()
    },
    noscriptContent () {
      return `
          <iframe src="https://www.googletagmanager.com/ns.html?id=${this.gaId}" 
                  height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `
    }
  },
  methods: {
    // 動的に増えた要素監視を開始するメソッド
    observeDynamicTags () {
      // MutationObserver インスタンスを作成
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
              if (
                node.nodeType === Node.ELEMENT_NODE &&
                ['LINK', 'SCRIPT', 'STYLE', 'IFRAME', 'DIV', 'NOSCRIPT', 'SPAN'].includes(node.tagName)
              ) {
                console.log('add_tag', node)
                this.observedNodes.push(node)
              }
            })
          }
        })
      })

      // headとbodyを監視
      this.observer.observe(document.body, { childList: true, subtree: true })
      this.observer.observe(document.head, { childList: true, subtree: true })
    },
    removeAllObservedTags () {
      this.observedNodes.forEach((node) => {
        if (node.parentNode) {
          node.remove()
        }
      })

      // 削除後、リストをクリア
      this.observedNodes = []
    },
    removePageLayout () {
      // このページ専用のcssの削除
      this.removeExternalCSS('https://use.typekit.net/jhq7wgy.css')
      this.removeExternalCSS('https://cdn.jsdelivr.net/npm/yakuhanjp@3.2.0/dist/css/yakuhanjp.min.css')
      this.removeExternalCSS('https://cdnjs.cloudflare.com/ajax/libs/Swiper/5.4.5/css/swiper.min.css')
      this.removeExternalCSS('https://cdnjs.cloudflare.com/ajax/libs/froala-editor/3.2.7/css/froala_style.min.css')
      this.removeExternalCSS('https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/magnific-popup.min.css')
      this.removeExternalCSS('https://unpkg.com/scroll-hint@latest/css/scroll-hint.css')
      this.removeExternalCSS('/lib/css/inspectiondetail.css')
      this.removeExternalCSS('https://sdk.gig.goleadgrid.com/section-assets/template_sections.css?1a29b19769e9cd62e1e9a47547857205eab76cdd')
      this.removeExternalCSS('https://cdnjs.cloudflare.com/ajax/libs/highlight.js/10.7.1/styles/vs2015.min.css')
      this.removeExternalCSS('https://cdn.jsdelivr.net/npm/@splidejs/splide@latest/dist/css/splide.min.css')
      // GTMスクリプトを削除
      const gtmScript = document.getElementById('gtm-script')
      if (gtmScript) gtmScript.remove()

      // Google Site Verificationのmetaタグを削除
      const metaTag = document.getElementById('google-verification')
      if (metaTag) metaTag.remove()

      // このページ専用のjsの削除
      // mathjaxは状態のリセットもしないといけない
      this.removeMathJaxScript('https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js')
      this.removeExternalJS('https://code.jquery.com/jquery-3.4.1.min.js')
      this.removeExternalJS('https://unpkg.com/scroll-hint@latest/js/scroll-hint.min.js')
      this.removeExternalJS('https://cdnjs.cloudflare.com/ajax/libs/Swiper/5.4.5/js/swiper.min.js')
      this.removeExternalJS('/lib/js/inspectionedetail.js')
      this.removeExternalJS('/lib/js/webfontconfig.js')
      this.removeExternalJS('https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js')
      this.removeExternalJS('https://cdn.embedly.com/widgets/platform.js')
      this.removeExternalJS('https://cdnjs.cloudflare.com/ajax/libs/highlight.js/10.7.1/highlight.min.js')
      this.removeExternalJS('https://cdnjs.cloudflare.com/ajax/libs/highlightjs-line-numbers.js/2.8.0/highlightjs-line-numbers.min.js')
      this.removeExternalJS('https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js')
      this.removeExternalJS('https://cdn.jsdelivr.net/npm/@splidejs/splide-extension-auto-scroll@0.5.3/dist/js/splide-extension-auto-scroll.min.js')

      // webfontconfig付与されるクラスを削除
      document.documentElement.classList.remove(
        'wf-notosansjp-n4-active',
        'wf-notosansjp-n5-active',
        'wf-notosansjp-n7-active',
        'wf-active'
      )
      // クラスリストが空であれば classの記述を削除(残っていても動作に支障はでないが削除する)
      if (!document.documentElement.classList.length) {
        document.documentElement.removeAttribute('class')
      }

      // 監視中に増えた要素の削除(主に依存関係で自動挿入されてしまう物を削除)
      this.removeAllObservedTags()
      // MutationObserver を停止
      if (this.observer) {
        this.observer.disconnect()
      }
    },
    // cssを動的に読み込む
    loadExternalCSS (href) {
      return new Promise((resolve) => {
        // すでに読み込まれているか確認
        const existingLink = Array.from(document.querySelectorAll('link')).find(link =>
          link.href.includes(href)
        )
        if (existingLink) {
          resolve() // すでに存在する場合はスキップ
          return
        }

        const link = document.createElement('link')
        link.rel = 'stylesheet'
        link.href = href
        document.head.appendChild(link)

        link.onload = () => {
          console.log(`loaded CSS: ${href}`)
          resolve()
        }
        link.onerror = () => {
          console.warn(`Failed to load CSS: ${href}`)
          resolve()
        }
      })
    },
    removeExternalCSS (src) {
      return new Promise((resolve) => {
        const links = document.querySelectorAll('link')

        links.forEach((link) => {
          if (link.href.includes(src)) {
            link.parentNode.removeChild(link)
            console.log(`CSS Removed: ${src}`)
          }
        })
        resolve()
      })
    },
    // jsを動的に読み込む
    loadExternalJS (url, id) {
      return new Promise((resolve, reject) => {
        // 既に同じURLのスクリプトが読み込まれている場合はスキップ
        const existingScript = Array.from(document.getElementsByTagName('script')).find(
          script => script.src.includes(url)
        )

        if (existingScript) {
          console.log(`JS already loaded: ${url}`)
          resolve()
          return
        }

        const script = document.createElement('script')
        script.src = url
        script.async = true
        if (id) {
          script.id = id
        }

        script.onload = () => {
          console.log(`JS Loaded: ${url}`)
          resolve()
        }

        script.onerror = () => {
          console.warn(`Failed to load JS: ${url}`)
          resolve()
        }

        document.body.appendChild(script)
      })
    },

    removeExternalJS (url) {
      return new Promise((resolve) => {
        // 指定されたURLのスクリプトを検索
        const script = Array.from(document.getElementsByTagName('script')).find(
          script => script.src.includes(url)
        )

        if (script) {
          script.parentNode.removeChild(script)
          console.log(`JS Removed: ${url}`)
          resolve()
        } else {
          resolve()
        }
      })
    },
    removeMathJaxScript (url) {
      return new Promise((resolve) => {
        // MathJaxの状態をリセット
        if (window.MathJax) {
          window.MathJax.typesetClear() // 数式のキャッシュをクリア
          delete window.MathJax // グローバルオブジェクトを削除
        }

        // スクリプトタグを削除
        const script = Array.from(document.getElementsByTagName('script')).find(
          (s) => s.src.includes(url)
        )

        if (script) {
          script.parentNode.removeChild(script)
          console.log(`MathJax script removed: ${url}`)
        }

        resolve()
      })
    },
    modalOpen () {
      window.modalHeight = window.pageYOffset
      // トラッキング処理
      this.nativePVset('SHAKEN_TAISHO')
      this.nativeEVENTSet('ShakenSyosaiButton', 'MOVED_SHAKEN_TAISHO', 'TAP')
      window.scrollTo(0, 0)
      this.modalActive = true
    },
    modalClose () {
      window.scrollTo(0, window.modalHeight)
      this.modalActive = false
    },
    sameUrlScroll (number) {
      if (this.$route.hash.slice(-1) === number) {
        document.getElementById(this.$route.hash.replace(/^#/, ''))
        this.$SmoothScroll(
          document.querySelector(this.$route.hash),
          500,
          null,
          null,
          'y'
        )
      }
    },
    toInitial () {
      this.currentState = IS_INITIAL
      window.scrollTo(0, 0)
    },
    toAgreement () {
      this.currentState = IS_AGREEMENT
      this.nativeEVENTSet('ShakenSyosaiButton', 'MOVED_SHAKEN_KOKANKIJYUN', 'TAP')
      window.scrollTo(0, 0)
    },
    eventTrackStartCar () {
      this.nativeEVENTSet('ShakenSyosaiButton', 'MOVED_SHAKEN_MITSUMORI', 'TAP')
    },
    appChangeMySs () {
      // 戻るボタンの出し分け
      this.appDisplayBack(false)
      if ('Android' in window) {
        /* eslint-disable-next-line no-undef */
        Android.changeMySs()
      } else if ('webkit' in window) {
        /* eslint-disable-next-line no-undef */
        webkit.messageHandlers.changeMySs.postMessage('')
      }
    },
    openErrorModal (message) {
      modal.alert(message)
    },
    nextPage (ssInfo, profileInfo, nativeData, versionData) {
      if (this.inspectionFlag) {
        // 車検予約あり
        return
      }
      const ssInfoStore = useSsInfoStore()
      ssInfoStore.ssInfo = ssInfo
      const profileInfoStore = useProfileInfoStore()
      profileInfoStore.profileInfo = profileInfo
      const nativeDataStore = useNativeDataStore()
      nativeDataStore.nativeData = nativeData
      const versionDataStore = useVersionDataStore()
      versionDataStore.versionData = versionData
      this.eventTrackStartCar()
      // 条件入力に遷移
      this.$router.push({ name: 'CarV3' })
    }
  },
  watch: {
    $route: function (n, o) {
      if (n.hash.match(/^#/)) {
        document.getElementById(n.hash.replace(/^#/, ''))
        this.$SmoothScroll(
          document.querySelector(n.hash),
          500,
          null,
          null,
          'y'
        )
      }
    },
    loading (newVal) {
      // ローディングが終わってDOM要素が表示されたタイミング以降にjsをよみこまなければいけない
      if (!newVal) {
        setTimeout(() => {
          // 動的に増えたタグの監視を開始
          this.observeDynamicTags()
          this.loadExternalJS('https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js', 'loadExternalJS')
          this.loadExternalJS('https://unpkg.com/scroll-hint@latest/js/scroll-hint.min.js')
          this.loadExternalJS('https://code.jquery.com/jquery-3.4.1.min.js').then(() => this.loadExternalJS('https://cdnjs.cloudflare.com/ajax/libs/Swiper/5.4.5/js/swiper.min.js').then(() => this.loadExternalJS('/lib/js/inspectionedetail.js')))
          this.loadExternalJS('/lib/js/webfontconfig.js')
          this.loadExternalJS('https://cdn.embedly.com/widgets/platform.js')
          this.loadExternalJS('https://cdnjs.cloudflare.com/ajax/libs/highlight.js/10.7.1/highlight.min.js').then(() => this.loadExternalJS('https://cdnjs.cloudflare.com/ajax/libs/highlightjs-line-numbers.js/2.8.0/highlightjs-line-numbers.min.js'))
          this.loadExternalJS('https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js')
          this.loadExternalJS('https://cdn.jsdelivr.net/npm/@splidejs/splide-extension-auto-scroll@0.5.3/dist/js/splide-extension-auto-scroll.min.js')

          if (this.isViewGatag === true) {
            // dataLayerの初期化
            const newEvent = {
              'gtm.start': new Date().getTime(),
              event: 'gtm.js',
              consent: 'default'
            }

            // dataLayer内に同じeventがない場合のみ追加
            if (Array.isArray(window.dataLayer)) {
              if (!window.dataLayer.some(item => item.event === newEvent.event)) {
                window.dataLayer.push(newEvent)
              }
            }

            // GTMタグを追加
            if (!document.getElementById('gtm-script')) {
              const gtmScript = document.createElement('script')
              gtmScript.async = true
              gtmScript.src = 'https://www.googletagmanager.com/gtm.js?id=' + this.gaId
              gtmScript.id = 'gtm-script'
              document.head.appendChild(gtmScript)
            }

            // Google Site Verificationのmetaタグ
            if (!document.getElementById('google-verification')) {
              const metaTag = document.createElement('meta')
              metaTag.name = 'google-site-verification'
              metaTag.content = process.env.VUE_APP_GA_CONTENT
              metaTag.id = 'google-verification'
              document.head.appendChild(metaTag)
            }
          }
        }, 100)
      }
    }
  },
  async mounted () {
    console.log(location.href)

    // 車検詳細用ページ用のcss
    this.loadExternalCSS('https://use.typekit.net/jhq7wgy.css')
    this.loadExternalCSS('https://cdn.jsdelivr.net/npm/yakuhanjp@3.2.0/dist/css/yakuhanjp.min.css')
    this.loadExternalCSS('https://cdnjs.cloudflare.com/ajax/libs/Swiper/5.4.5/css/swiper.min.css')
    this.loadExternalCSS('https://cdnjs.cloudflare.com/ajax/libs/froala-editor/3.2.7/css/froala_style.min.css')
    this.loadExternalCSS('https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/magnific-popup.min.css')
    this.loadExternalCSS('https://unpkg.com/scroll-hint@latest/css/scroll-hint.css')
    this.loadExternalCSS('/lib/css/inspectiondetail.css')
    this.loadExternalCSS('https://sdk.gig.goleadgrid.com/section-assets/template_sections.css?1a29b19769e9cd62e1e9a47547857205eab76cdd')
    this.loadExternalCSS('https://cdnjs.cloudflare.com/ajax/libs/highlight.js/10.7.1/styles/vs2015.min.css')
    this.loadExternalCSS('https://cdn.jsdelivr.net/npm/@splidejs/splide@latest/dist/css/splide.min.css')
    $(document).ready(function () {
      $('.faq-item').on('click', function () {
        if ($(this).hasClass('active')) {
          $(this).removeClass('active')
          $(this).children('.faq-a').stop().slideUp(300)
        } else {
          $('.faq-item').removeClass('active')
          $(this).addClass('active')
          $('.faq-a').slideUp(200)
          $(this).children('.faq-a').stop().slideDown(200)
        }
      })
      $(window).on('scroll', function () {
        // eslint-disable-next-line no-new-object
        const obj = new Object()
        obj.y = document.documentElement.scrollTop || document.body.scrollTop
        // var hBtn = $('.section2 .info').outerHeight()
        // var offSet1 = $('.info').offset().top + hBtn
        if (!$('.offset2').length) {
          return
        }
        const offSet2 = $('.offset2').offset().top + 30
        if (obj.y > offSet2) {
          $('.info__btn1').addClass('fixed')
        } else {
          $('.info__btn1').removeClass('fixed')
        }
      })
      function setEqualHeight (columns) {
        let tallestcolumn = 0
        columns.each(function () {
          const currentHeight = $(this).height()
          if (currentHeight > tallestcolumn) {
            tallestcolumn = currentHeight
          }
        })
        columns.height(tallestcolumn)
      }
      const delay = (function () {
        let timer = 0
        return function (callback, ms) {
          clearTimeout(timer)
          timer = setTimeout(callback, ms)
        }
      })()
      delay(function () {
        $('.slide-info').css('height', 'auto')
        setEqualHeight($('.slide-info'))
        $('.section3 .list-item').css('height', 'auto')
        setEqualHeight($('.section3 .list-item'))
        $('.section7 .list-item').css('height', 'auto')
        setEqualHeight($('.section7 .list-item'))
      }, 500)
      $(window).resize(function () {
        delay(function () {
          $('.slide-info').css('height', 'auto')
          setEqualHeight($('.slide-info'))
          $('.section3 .list-item').css('height', 'auto')
          setEqualHeight($('.section3 .list-item'))
          $('.section7 .list-item').css('height', 'auto')
          setEqualHeight($('.section7 .list-item'))
        }, 500)
      })
    })

    this.ssInfo = this.ssInfoStore.ssInfo
    this.profileInfo = this.profileInfoStore.profileInfo
    this.nativeData = this.nativeDataStore.nativeData
    this.versionData = this.versionDataStore.versionData
    this.tsId = this.nativeDataStore.nativeData.tsid
    this.popinfoid = this.nativeDataStore.nativeData.popinfoid
    this.otoken = this.nativeDataStore.nativeData.otoken

    let isApiError = false
    // inspection(予約)データ取得
    inspection.get(this.tsId).then(res => {
      console.log(res.data)
      if (res.data.inspections.length === 0) {
        this.inspectionFlag = false
      }
    }).catch(e => {
      if (!isApiError) {
        this.openErrorModal('エラーが発生しました。')
        isApiError = true
      }
    })

    console.log(location.href)
    // 戻るボタンの出し分け
    this.appDisplayBack(true)
    this.nativePVset('SHAKEN_DETAIL')

    // 動的にcss適用する際にちらつきが発生する場合があるため500ミリ秒遅くローディング中を解除する
    setTimeout(() => {
      this.loading = false
    }, 500)
  },
  components: {
    Agreement,
    Loading,
    Slick
  }
}
</script>
